// extracted by mini-css-extract-plugin
module.exports = {"layer":"GuideToApp_layer__Vz6l7","description":"GuideToApp_description__zXFnJ","guideToApp":"GuideToApp_guideToApp__E59dw","button":"GuideToApp_button__3jJoy"};